module.exports = __webpack_public_path__ + "img/The_Power_of_Efficiency_Big_O_Analysis.1fabbff7.jpeg";